module.exports = __webpack_public_path__ + "static/media/lrc.cb11a1c2.svg";